import Container from './Container';
import Reveal from '../../../components/Reveal';
import andyPeek from './../../../assets/images/andy-peek.png';

const REGISTER_URL = 'https://app.schoolhack.ai/auth/register';

const CTA = () => {
  return (
    <section className="relative py-16 lg:py-20">
      <Container>
        <Reveal className="relative">
          {/* Andy peeking from behind the card's left edge */}
          <img
            src={andyPeek}
            alt="Andy"
            className="absolute left-[-40px] top-[34%] z-20 h-40 w-auto -translate-x-[50%] -translate-y-1/2 object-contain drop-shadow-[0_12px_30px_rgba(0,0,0,0.5)] lg:h-52"
          />

          <div className="card-dark relative overflow-hidden rounded-[2rem] border border-white/8 px-6 py-14 text-center md:px-10 md:py-16">
            <div className="glow left-1/2 top-[-90px] h-[300px] w-[520px] -translate-x-1/2 bg-accent/10" />

            <h2 className="head-fade font-heading relative mx-auto max-w-2xl text-[2rem] font-bold leading-[1.1] sm:text-[2.6rem] lg:text-[3rem]">
              Ready to Transform
              <br />
              Your Studies?
            </h2>
            <p className="relative mx-auto mt-4 max-w-md text-[1rem] text-white/60">
              Step into the future of education.
            </p>
            <a
              href={REGISTER_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-primary relative mt-8 px-7 py-3.5 text-[0.95rem]"
            >
              Sign up for free
            </a>
          </div>
        </Reveal>
      </Container>
    </section>
  );
};

export default CTA;
